import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ImageSlider from "./helpers/imageSlider";
import sidebarAndDashboardContent from "../assets/sidebar-data.png";
import inventory from "../assets/inventory.png";
import dropers from "../assets/droper-detail.png";
import stores from "../assets/stores.png";
import routes from "../assets/route-detail.png";
import reports from "../assets/reports.png"

const HeroSection = ({ openModal }) => {
  const images = [
    sidebarAndDashboardContent, inventory, stores, routes, dropers, reports
  ];

  return (
    <section id="hero" className="bg-lightGray py-12 min-h-screen">
      <div
        className="container mx-auto flex flex-col lg:flex-row items-center gap-6 px-4 mt-10"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        {/* Text Section */}
        <div
          className="lg:w-1/2 text-center lg:text-left"
          data-aos="fade-right"
          data-aos-delay="200"
        >
          <h1
            className="text-3xl sm:text-4xl font-bold text-navy"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            Revolutionize Your Inventory Management with INVETIX
          </h1>
          <p
            className="text-gray-700 mt-4"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Track stock levels, manage customers, and optimize delivery routes
            seamlessly.
          </p>
          <div
            className="mt-6 space-x-4"
            data-aos="fade-up"
            data-aos-delay="700"
          >
            <button
              className="bg-navy text-white px-6 py-3 rounded hover:bg-blue-800 transition duration-300"
              onClick={openModal}
            >
              Learn More
            </button>
          </div>
        </div>

        {/* Image Slider Section */}
        <div
          className="lg:w-2/3 w-full"
          data-aos="fade-left"
          data-aos-delay="400"
          data-aos-duration="1200"
        >
          <ImageSlider images={images} />
        </div>
      </div>
      <div
        className="container mx-auto flex flex-col items-center gap-6 px-4 mt-10"
        data-aos="fade-left"
        data-aos-delay="200"
      >
        <h2 className="text-3xl font-bold text-navy text-start w-full mt-4">
          What is INVETIX?
        </h2>
        <p className="text-gray-700 mt-4 text-start w-full">
          INVETIX is an all-in-one inventory management system designed to
          streamline your stock, customer, and delivery operations. From
          real-time tracking to automated reporting, INVETIX has got you
          covered.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;

